/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { CustomerPwdNewDto } from '../model/customerPwdNewDto';
import { CustomerPwdResetDto } from '../model/customerPwdResetDto';
import { CustomerSignupDto } from '../model/customerSignupDto';
import { UsrSecurityQuestDto } from '../model/usrSecurityQuestDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CustomerSignupControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * checkEmail
     * 
     * @param emailId emailId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkEmailUsingGET(emailId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public checkEmailUsingGET(emailId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public checkEmailUsingGET(emailId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public checkEmailUsingGET(emailId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (emailId === null || emailId === undefined) {
            throw new Error('Required parameter emailId was null or undefined when calling checkEmailUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/dlp/customer/signup/checkEmail/${encodeURIComponent(String(emailId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * checkPhone
     * 
     * @param phoneNo phoneNo
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkPhoneUsingGET(phoneNo: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public checkPhoneUsingGET(phoneNo: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public checkPhoneUsingGET(phoneNo: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public checkPhoneUsingGET(phoneNo: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (phoneNo === null || phoneNo === undefined) {
            throw new Error('Required parameter phoneNo was null or undefined when calling checkPhoneUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/dlp/customer/signup/checkPhone/${encodeURIComponent(String(phoneNo))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchQuestions
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchQuestionsUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<UsrSecurityQuestDto>>;
    public fetchQuestionsUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UsrSecurityQuestDto>>>;
    public fetchQuestionsUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UsrSecurityQuestDto>>>;
    public fetchQuestionsUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<UsrSecurityQuestDto>>(`${this.basePath}/dlp/customer/signup/securityQuestions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * forgotPassword
     * 
     * @param customerNewPwdDto customerNewPwdDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public forgotPasswordUsingPOST(customerNewPwdDto: CustomerPwdNewDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public forgotPasswordUsingPOST(customerNewPwdDto: CustomerPwdNewDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public forgotPasswordUsingPOST(customerNewPwdDto: CustomerPwdNewDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public forgotPasswordUsingPOST(customerNewPwdDto: CustomerPwdNewDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (customerNewPwdDto === null || customerNewPwdDto === undefined) {
            throw new Error('Required parameter customerNewPwdDto was null or undefined when calling forgotPasswordUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/dlp/customer/pwd/forgot`,
            customerNewPwdDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * newCustomer
     * 
     * @param customerSignupDto customerSignupDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newCustomerUsingPOST(customerSignupDto: CustomerSignupDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public newCustomerUsingPOST(customerSignupDto: CustomerSignupDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public newCustomerUsingPOST(customerSignupDto: CustomerSignupDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public newCustomerUsingPOST(customerSignupDto: CustomerSignupDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (customerSignupDto === null || customerSignupDto === undefined) {
            throw new Error('Required parameter customerSignupDto was null or undefined when calling newCustomerUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/dlp/customer/signup`,
            customerSignupDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * resetPassword
     * 
     * @param customerPwdResetDto customerPwdResetDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetPasswordUsingPOST(customerPwdResetDto: CustomerPwdResetDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resetPasswordUsingPOST(customerPwdResetDto: CustomerPwdResetDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resetPasswordUsingPOST(customerPwdResetDto: CustomerPwdResetDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resetPasswordUsingPOST(customerPwdResetDto: CustomerPwdResetDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (customerPwdResetDto === null || customerPwdResetDto === undefined) {
            throw new Error('Required parameter customerPwdResetDto was null or undefined when calling resetPasswordUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/dlp/customer/pwd/reset`,
            customerPwdResetDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
